import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import img from '../../assets/icon-submit-success.png';

export const Root = styled(Box)({
    width: '100%',
    '& .wapper': {
        width: '100%',
        '& .card': {
            width: '1200px',
            padding: '',
            backgroundColor: '#fff',
            '& .card-head': {
                padding: '24px',
            },
            '& .card-content': {
                backgroundColor: '#FAFAFA',
                '& .card-l': {
                    width: '280px',
                },
                '& .card-r': {
                    padding: '0 24px 24px 24px',
                    backgroundColor: '#fff',
                },
            },
            '& .card-foot': {
                '& .btn': {
                    marginRight: '20px',
                },
            },
            '& .complete-wapper': {
                width: '100%',
                height: '500px',
                color: '#0060A0',
                fontSize: '22px',
                fontWeight: 'bold',
                '& .img': {
                    width: '74px',
                    height: '74px',
                    background: `url(${img}) no-repeat center top/cover`,
                },
                '& .text': {
                    margin: '20px 0',
                },
            },
        },
    },
    '& .head': {
        marginBottom: '17px',
        '& .subtitle': {
            color: '#9B9B9B',
            fontSize: '12px',
        },
        '& .title': {
            color: '#005E96',
            fontSize: '16px',
            textDecoration: 'none',
            cursor: 'pointer',
        },
        '& .crtTitle': {
            color: '#005E96',
            fontSize: '16px',
            fontWeight: 'bold',
        },
    },
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#A1A1A1',
        opacity: '0.13',
    },
    '& .mb-20': {
        marginBottom: '20px',
    },
    '& .mt-20': {
        marginTop: '20px',
    },
    '& .refealBtn': {
        backgroundColor: '#C1553A !important',
        color: '#fff',
        marginRight: '20px',
    },
});